import React, { Fragment } from "react";
import _ from "lodash";
import PropTypes from "prop-types";

const SearchResultsLoading = ({ isMobile }) => {
  return _.times(2, i => (
    <div className="advanced-search__tile-row" key={i}>
      <div className="advanced-search__tile --left-border">
        {_.times(4, index => (
          <div className="--loading-bar --tile" key={index} />
        ))}
      </div>

      {!isMobile && (
        <Fragment>
          <div className="advanced-search__tile">
            {_.times(4, index => (
              <div className="--loading-bar --tile" key={index} />
            ))}
          </div>
          <div className="advanced-search__tile">
            {_.times(4, index => (
              <div className="--loading-bar --tile" key={index} />
            ))}
          </div>
          <div className="advanced-search__tile --large">
            {_.times(4, index => (
              <div className="--loading-bar --tile" key={index} />
            ))}
          </div>
        </Fragment>
      )}
    </div>
  ));
};

SearchResultsLoading.propTypes = {
  isMobile: PropTypes.bool
};

SearchResultsLoading.defaultProps = {
  isMobile: false
};

export default SearchResultsLoading;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/SearchResultsLoading.js